import { getConfig } from '@/lib/get-config';
import { ObjectKeys } from '@/lib/utils';
import type { BaseInstance, ModelName } from '@pigello/pigello-matrix';

export const OBJECT_COMPONENT = 'object_component' as const;
export const ROOM = 'room' as const;
export const INSPECTION_ERRAND_NOTES = 'inspection_errand_notes' as const;
export const INSPECTION_ERRAND_CHECKLISTS =
  'inspection_errand_checklists' as const;

export function getInstanceDisplayValue<
  TInstance extends BaseInstance = BaseInstance,
>(
  instance: TInstance | null | undefined,
  modelName: ModelName | undefined
): string | undefined {
  if (!instance || !modelName) {
    return undefined;
  }

  const config = getConfig<ModelName, TInstance>(modelName);

  if (!config) {
    return '-';
  }

  const displayName = config.displayFieldName as keyof TInstance;

  if (config.displayFieldName !== 'id' && instance[displayName] != null) {
    return String(instance[displayName]);
  }

  const key = ObjectKeys(instance).find((key) => {
    if (key === 'id') {
      return false;
    }
    return config.previewFields.includes(key);
  });

  if (key && instance[key] != null) {
    return String(instance[key]);
  }

  return config.verboseName;
}
